<template>
  <div class="reveal-overlay">
    <div class="reval c-password-reset-popin__wrapper" style="display:block;">
      <div class="c-pop-up c-pop-up--third c-password-reset-popin">
        <div class="c-pop-up__close-button" @click="closeForget">
          <button class="c-button c-button--rounded l-login-popin__close-toggler c-button--close" type="button">
            <i class="iconfont">&#xe615;</i>
          </button>
        </div>
        <div class="heading-h2">忘记密码了吗 ？</div>
        <template v-if="step == 2">
          <div class="heading-h6">验证码将发送至您的手机 {{phone}}，请注意查收</div>
          <VForm :model="secondForm" :rule="secondRules" ref="secondForm">
            <FormItem prop="smsCode">
              <input type="text" :class="[codeError?'c-input-error':'','c-input', 'c-input--fullwidth']" placeholder="* 短信验证码" v-model="secondForm.smsCode" autocomplete="off" />
              <div class="error-msg" v-if="codeError">{{codeMsg}}</div>
            </FormItem>
          </VForm>
          <FormItem prop="password">
            <div style="position: relative;">
              <input 
                :type="iptType" v-model="secondForm.password" :readonly="iptType=='text'" 
                :class="[passwordError?'c-input-error':'', 'c-input', 'c-input--fullwidth']" placeholder="* 新密码"
                minlength="6" maxlength="16" 
                @keyup="secondForm.password=secondForm.password.replace(/[\u4e00-\u9fa5]/ig,'')" 
                @paste.capture.prevent="returnFalse()"
                @drop.capture.prevent="returnFalse()" 
                @contextmenu.capture.prevent="returnFalse()" 
                pattern="[^\u4e00-\u9fa5]{8,}" 
              />
              <template v-if="isMobile">
                <button class="eye-icon__container" @touchstart="toggleIptType" @touchend="toggleIptType">
                  <i class="iconfont">&#xe608;</i>
                </button>
              </template>
              <template v-else>
                <button class="eye-icon__container" @mousedown="toggleIptType" @mouseup="toggleIptType">
                  <i class="iconfont">&#xe608;</i>
                </button>
              </template>
            </div>
            <div class="error-msg" v-if="passwordError">{{passwordMsg}}</div>
          </FormItem>
          <div class="c-button-send text--right">
            <button class="c-button c-button--primary" :disabled="disabledSubmit" @click="setPassword">提交</button>
          </div>
        </template>
        <template v-else>
          <div class="heading-h6">输入您注册时的手机号码以重置您的密码</div>
          <VForm :model="firstForm" :rule="firstRules" ref="firstForm">
            <FormItem prop="memberPhone">
              <input type="text" :class="[accountError?'c-input-error':'','c-input', 'c-input--fullwidth']" placeholder="* 手机号码" v-model="firstForm.mobile" autocomplete="off" />
              <div class="error-msg" v-if="accountError">{{accountMsg}}</div>
            </FormItem>
          </VForm>
          <FormItem prop="phoneCode">
            <div style="position: relative;">
              <input type="text" :class="[capthaError?'c-input-error':'','c-input','c-input--fullwidth']" placeholder="图形验证码" v-model="firstForm.imgCode" autocomplete="off" />
              <img class="pic-code" :src="captchaImg" alt @click="getCaptcha" />
            </div>
            <div class="error-msg" v-if="capthaError">{{capthaMsg}}</div>
          </FormItem>
          <div class="c-button-send text--right">
            <button class="c-button c-button--primary" :disabled="disalbedSendSMS" @click="checkCaptha">发送验证码</button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import VForm from "@/components/form/my-form";
import FormItem from "@/components/form/form-item";
import types from '@/store/types';
import api from '@/utils/api';
import utils from '@/utils';

export default {
  components: { VForm, FormItem },
  data() {
    return {
      captchaId: "",
      captchaImg: "",
      iptType: "password",
      firstForm: {
        mobile: "",
        imgCode: ""
      },
      firstRules: {
        mobile: [{
          validator(fieldRule, value, callback) {
            if (!value) {
              callback(new Error("请输入手机号码"));
            } else if (!/^1[3456789]\d{9}$/.test(value)) {
              callback(new Error("手机号码格式不正确"));
            } else {
              callback();
            }
          }, trigger: "blur"
        }],
        imgCode: [{ required: true, message: "请输入图形验证码", trigger: "blur" }]
      },
      secondForm: {
        smsCode: "",
        password: ""
      },
      secondRules: {
        smsCode: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
        password: [{
          validator(fieldRule, value, callback) {
            if (!value) {
              return callback(new Error("密码不能为空"));
            } else if (!/(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*()_.]+)$)^[\w~!@#$%^&*()_.]{8,16}$/.test(value)) {
              callback(new Error("应为字母,数字,特殊符号,两种及以上组合,长度8-16"));
            } else {
              callback();
            }
          }, trigger: "blur"
        }]
      },
      step: 1,
      phone: "",
      msg_code: "",
      password: "",
      capthaError:false,
      capthaMsg:'',
      codeError:false,
      codeMsg:'',
      accountError:false,
      accountMsg:'',
      passwordError:false,
      passwordMsg:''
    };
  },
  created() {
    this.getCaptcha();
  },
  methods: {
    // 获取图形验证码
    getCaptcha() {
      api[types.GET_CAPTCHA]().then(res => {
        this.captchaImg = res.data.img;
        this.captchaId = res.data.key;
      }).catch();
    },
    // 校验图形验证码
    checkCaptha() {
      api[types.CHECK_CAPTCHA]({
        valid_id: this.captchaId,
        valid_code: this.firstForm.imgCode
      }).then(res => {
        if (res.code == 1) {
          this.capthaError=false;
          this.capthaMsg='';
          this.sendSMS();
        } else {
          this.capthaError=true;
          this.capthaMsg=res.message;
          // this.$message({ message: res.message });
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    // 关闭弹窗
    closeForget() {
      this.$emit("close");
      this.step = 1;
       this.capthaError=false;
      this.capthaMsg='';
      this.codeError=false;
      this.codeMsg='';
      this.passwordError=false;
      this.passwordMsg='';
      this.firstForm = { mobile: "", imgCode: "" };
      this.secondForm = { smsCode: "", password: "" };
    },
    // 切换密码框输入类型
    toggleIptType() {
      this.iptType = this.iptType == "password" ? "text" : "password";
    },
    returnFalse() {
      return false;
    },
    // 发送短信
    sendSMS() {
      api[types.SEND_MSG]({
        phone: this.firstForm.mobile,
        valid_id: this.captchaId,
        valid_code: this.firstForm.imgCode,
        type: 3
      }).then(res => {
        if (res.code == 1) {
          this.step = 2;
        } else {
          this.accountError=true,
          this.accountMsg=res.message
          // this.$toast({ message: res.message, iconCls: "failure" });
        }
      }).catch();
    },
    // 重置密码
    setPassword() {
      let { mobile: phone } = this.firstForm;
      let { smsCode: msg_code, password } = this.secondForm;
      api[types.SET_PASSWORD]({ phone, msg_code, password: utils.encrypt(password) }).then(res => {
        if (res.code == 1) {
          this.$toast({ message: res.message, iconCls: "success" });
          this.closeForget();
        } else {
          switch (res.data.field){
            case 'msg_code':
              this.codeError=true;
              this.codeMsg=res.message;
              break;
            case 'password':
              this.passwordError=true;
              this.passwordMsg=res.message;
              break;
          }
          
          // this.$toast({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => console.warn(err));
    }
  },
  computed: {
    isMobile() {
      return utils.isMobile();
    },
    disalbedSendSMS() {
      let { mobile, imgCode } = this.firstForm;
      if (/^1[3456789]\d{9}$/.test(mobile) && imgCode) {
        return false;
      }
      return true;
    },
    disabledSubmit() {
      let { smsCode, password } = this.secondForm;
      if (smsCode && password) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.reveal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.45);
}
.reval {
  z-index: 1000;
  padding: 1rem;
  border: 1px solid #cacaca;
  background-color: #fff;
  border-radius: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  min-width: 400px;
}
.c-pop-up__close-button {
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
}
.c-input-error{border: 1px solid #df4c4c;background: #ffeaea}
.error-msg{color: #df4c4c; padding: 0.175rem 1rem 0}
@media screen and (min-width: 48em) {
  .reval {
    min-height: 0;
    width: 600px;
    max-width: 75rem;
  }
  .c-password-reset-popin__wrapper {
    width: 40.1875rem;
  }
  .c-pop-up--third {
    padding: 1.5625rem 5rem;
  }
  .c-password-reset-popin {
    padding-top: 5.8125rem;
    padding-bottom: 5.8125rem;
  }
}
@media screen and (min-width: 64em) {
}
@media screen and (min-width: 75em) {
  .c-password-reset-popin__wrapper {
    width: 36.9375rem;
  }
  .c-password-reset-popin {
    padding-top: 5.4375rem;
    padding-bottom: 5.4375rem;
  }
}
</style>